import type { ReactNode } from 'react';

export const symbol_stars_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m323-245 157-94 157 95-42-178 138-120-182-16-71-168-71 167-182 16 138 120-42 178Zm157-24L294-157q-8 5-17 4.5t-16-5.5q-7-5-10.5-13t-1.5-18l49-212-164-143q-8-7-9.5-15.5t.5-16.5q2-8 9-13.5t17-6.5l217-19 84-200q4-9 12-13.5t16-4.5q8 0 16 4.5t12 13.5l84 200 217 19q10 1 17 6.5t9 13.5q2 8 .5 16.5T826-544L662-401l49 212q2 10-1.5 18T699-158q-7 5-16 5.5t-17-4.5L480-269Zm290-458-65 38q-5 2-9-.5t-2-7.5l17-72-57-48q-4-3-2.5-7.5t6.5-5.5l76-6 29-68q2-5 7-5t7 5l29 68 76 6q5 1 6.5 5.5T886-817l-57 48 17 72q2 5-2 7.5t-9 .5l-65-38ZM480-485Z"
		/>
	</svg>
);
